//npm install idb-keyval

import { get, set, del } from 'idb-keyval'

interface IndexedDBStorage {
  getItem: () => Promise<string | null>
  setItem: (_key: string, value: unknown) => Promise<void>
  removeItem: () => Promise<void>
}

export const indexedDBStorage = (key: string): IndexedDBStorage => ({
  getItem: async () => {
    const value = await get(key)
    return value ? JSON.stringify(value) : null
  },
  setItem: async (_key: string, value: unknown) => {
    await set(key, JSON.parse(value as string))
  },
  removeItem: async () => {
    await del(key)
  },
})